import axios from 'axios'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { AiOutlineBarcode } from 'react-icons/ai'
import { FaBoxOpen, FaShoppingCart } from 'react-icons/fa'
import { GiFactory } from 'react-icons/gi'
import { IExistence, IWarehouse } from 'safe'
import placeholder from '../../assets/images/img-placeholder.jpg'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import Datepicker from '../../components/Inputs/Datepicker'
import InputText from '../../components/Inputs/InputText'
import { TextArea } from '../../components/Inputs/TextArea'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { formatAmount } from '../../utils/utils'
import { getStatusColors } from './Transfers/ShowExistence'

const server = process.env.REACT_APP_SERVER_URL

const AdjustExistence: React.FC<AdjustExistenceProps> = ({
  existences,
  onClose,
  location,
}) => {
  const { addAlert } = useSnackBars()
  const form = useForm()

  // const [itemsToModify, setItemsToModify] = useState<ItemToTransfer[]>([])
  const [localExistences, setLocalExistences] = useState<IItemToAdjust[]>(
    () => [
      ...existences.map((existence) => ({
        ...existence,
        to_assign: existence.quantity,
      })),
    ]
  )
  const [amountToAdjust, setAmountToAdjust] = useState<number>(0)
  const [gains, setGains] = useState<number>(0)
  const [losses, setLosses] = useState<number>(0)
  const [net, setNet] = useState<number>(0)
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  const [values, setValues] =
    useState<{
      dateOfIssue: string
      purpose: string
      details: string
    } | null>(null)

  const changeQuantity = (
    existence: IItemToAdjust,
    to_adjust: string | number
  ) => {
    const to_assign = String(to_adjust)
    const localExistencesCopy = [...localExistences]
    const index = localExistencesCopy.findIndex(
      (exst) => exst.id === existence.id
    )
    if (index === -1) {
      addAlert({
        message: 'Todo esta mal, llame a soporte!!!',
        status: 'error',
      })
    }
    localExistencesCopy[index].to_assign = to_assign
    setLocalExistences(localExistencesCopy)
  }

  useEffect(() => {
    setAmountToAdjust(
      localExistences.reduce(
        (acc, a) => (+a.quantity !== +a.to_assign ? acc + 1 : acc),
        0
      )
    )
    const gains = localExistences.reduce(
      (acc, a) =>
        +a.quantity < +a.to_assign
          ? acc + +a?.item?.cost[0]?.amount * (+a.to_assign - +a.quantity)
          : acc,
      0
    )
    const losses = localExistences.reduce(
      (acc, a) =>
        +a.quantity > +a.to_assign
          ? acc + +a?.item?.cost[0]?.amount * (+a.to_assign - +a.quantity)
          : acc,
      0
    )
    const net = gains + losses
    setGains(gains)
    setLosses(losses)
    setNet(net)
  }, [localExistences])

  // const changeQuantity = (itemToModify: ItemToTransfer, quantity: string) => {
  //   const itemsReadyCopy = [...itemsToModify]
  //   const index = itemsReadyCopy.findIndex(
  //     (item) => item.id === itemToModify.id
  //   )
  //   itemsReadyCopy[index] = { ...itemsReadyCopy[index], quantity: +quantity }
  //   setItemsToModify(itemsReadyCopy)
  // }

  const makeAdjustment = async () => {
    try {
      addAlert({
        message: 'Cargando...',
        status: 'loading',
      })
      const itemsToAdjust = localExistences
        .map((existence) => ({
          idItem: existence.item.id,
          before: String(existence.quantity),
          after: String(existence.to_assign),
          amount: String(+existence.to_assign - +existence.quantity),
        }))
        .filter((item) => +item.amount !== 0)
      const itemsToLoad = itemsToAdjust
        .filter((item) => +item.amount > 0)
        .map((item) => {
          const { idItem, amount } = item
          return { idItem, amount }
        })
      const itemsToDischarge = itemsToAdjust
        .filter((item) => +item.amount < 0)
        .map((item) => {
          const { idItem, amount } = item
          return { idItem, amount: String(-1 * +amount) }
        })

      if (values) {
        const { dateOfIssue, purpose, details } = values

        const entity: any = {
          employee: {
            id: '1',
          },
          employeeAuthorizer: {
            id: '1',
          },
          dateOfIssue,
          purpose,
          details,
          earningsAmount: gains.toFixed(2),
          lossesAmount: losses.toFixed(2),
          netAmount: net.toFixed(2),
          itemsToAdjust,
          // load: {
          //   destination: {
          //     id: location.id,
          //     locationType: 'warehouse'
          //   },
          //   items: itemsToLoad
          // },
          // unload: {
          //   destination: {
          //     id: location.id,
          //     locationType: 'warehouse'
          //   },
          //   items: itemsToDischarge
          // },
          warehouse: {
            id: location.id,
          },
        }

        if (itemsToLoad.length) {
          entity.load = {
            destination: {
              id: location.id,
              locationType: 'warehouse',
            },
            items: itemsToLoad,
          }
        }

        if (itemsToDischarge.length) {
          entity.unload = {
            destination: {
              id: location.id,
              locationType: 'warehouse',
            },
            items: itemsToDischarge,
          }
        }

        await axios.post(
          `${server}/operations/movement/arbitrary-adjustment/`,
          { entity }
        )
        addAlert({
          message: 'ajuste realizado exitosamente',
          status: 'success',
        })
        onClose()
      }
    } catch (error: any) {
      addAlert({
        message:
          error.response.data.message ||
          'Error al realizar ajuste de inventario',
        status: 'error',
      })
    }
  }

  return (
    <motion.div
      key="origen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="grid grid-cols-12 gap-8"
    >
      <div className="xl:col-span-7 col-span-12 ">
        <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
          Artículos
        </h1>
        <div className="overflow-auto" style={{ height: '55vh' }}>
          {localExistences.map((existence) => (
            <ItemCard
              key={existence.id}
              existence={existence}
              changeQuantity={changeQuantity}
            />
          ))}
        </div>
      </div>
      <div className="xl:col-span-5 col-span-12" style={{ height: '50vh' }}>
        <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
          Datos de Ajuste
        </h1>
        <div className="flex justify-between">
          <div></div>
          <div className="flex mb-3">
            <div className="mr-4 text-primary-600">
              {location.warehouseType === 'SALE FLOOR' && (
                <FaShoppingCart
                  size="1.2rem"
                  className="dark:text-primaryGreen-300 text-primaryGreen-500"
                />
              )}
              {location.warehouseType === 'WAREHOUSE' && (
                <FaBoxOpen size="1.2rem" />
              )}
              {location.warehouseType === 'PRODUCTION' && (
                <GiFactory
                  size="1.2rem"
                  className="text-primaryOrange-dark dark:text-primaryOrange"
                />
              )}
            </div>
            <div className="truncate text-primary-600 font-medium text-sm dark:text-white">
              {location.name}
            </div>
          </div>
        </div>
        <div className="flex justify-between">
          <div
            className={`${
              net > 0 ? 'text-green-900' : net === 0 ? '' : 'text-red-900'
            }`}
          >
            Neto: {net.toFixed(2)} Bs
          </div>
          {amountToAdjust === 0 ? (
            <p>No hay artículos para modificar</p>
          ) : (
            <div className="truncate text-primary-600 font-medium text-sm dark:text-white">
              <span className="mr-3">Artículos a modificar: </span>
              <span> {amountToAdjust}</span>
            </div>
          )}
        </div>
        <div className="flex justify-between">
          <div className={`${gains > 0 && 'text-green-900'}`}>
            Ganancias: {gains.toFixed(2)} Bs
          </div>
          <div className={`${losses < 0 && 'text-red-900'}`}>
            Pérdidas: {losses.toFixed(2)} Bs
          </div>
        </div>
        <Form
          form={form}
          onSubmit={(values) => {
            setValues(values)
            setConfirmModal(true)
          }}
          classes={`gap-x-6 gap-y-2 `}
        >
          <FormItem
            name="dateOfIssue"
            classes="col-span-12"
            rules={{
              required:
                'Debe especificar la fecha de emisión de la nota de entrega',
            }}
          >
            <Datepicker label="Fecha de Emisión" />
          </FormItem>

          <FormItem
            name="responsible"
            classes="col-span-12"
            rules={{
              required: 'Debe especificar el responsable de la operación',
            }}
          >
            <InputText label="Responsable" maxLength={255} />
          </FormItem>

          <FormItem
            name="authorized"
            classes="col-span-12"
            rules={{
              required: 'Debe especificar el autorizante de la operación',
            }}
          >
            <InputText label="Autorizado Por" maxLength={255} />
          </FormItem>

          <FormItem
            name="purpose"
            classes="col-span-12"
            rules={{ required: 'Debe especificar el propósito' }}
          >
            <InputText label="Propósito" maxLength={255} />
          </FormItem>

          <FormItem name="details" classes="col-span-12">
            <TextArea
              label="Detalles"
              placeholder="Coloque breve texto explicativo de su correción..."
              maxLength={255}
              rows={4}
            />
          </FormItem>
          <div className="col-span-12 flex space-x-2 px-1 mt-3">
            <Button
              type="outline"
              classes="w-1/2 mr-4"
              onClick={() => onClose()}
              htmlType="button"
            >
              Cancelar
            </Button>

            <Button
              type="primary"
              classes="w-1/2 mr-4"
              htmlType="submit"
              disabled={!amountToAdjust}
            >
              Ajustar Inventario
            </Button>
          </div>
        </Form>
      </div>

      <ModalConfirm
        positive={true}
        title="¿Deseas realizar este ajuste de existencia?"
        displayConfirmModal={confirmModal}
        onCancel={() => {
          setConfirmModal(false)
        }}
        onConfirm={() => {
          setConfirmModal(false)
          makeAdjustment()
        }}
      />
    </motion.div>
  )
}

const ItemCard: React.FC<IItemCardProps> = ({ existence, changeQuantity }) => {
  const { item, quantity } = existence
  return (
    <div
      key={item.id}
      className={`flex items-center flex-nowrap px-3 py-2 space-between space-x-3 overflow-auto ${
        +existence.quantity > +existence.to_assign
          ? 'dark:bg-red-900 bg-red-200'
          : +existence.quantity < +existence.to_assign
          ? 'dark:bg-green-900 bg-green-200'
          : 'dark:bg-black'
      }`}
    >
      <img
        className="h-10 w-10 object-cover rounded-lg shadow-inner"
        src={item.images[0]?.url || placeholder}
        alt={item.sku}
      ></img>
      <div className="flex items-center space-y-1 justify-between md:space-x-3 flex-grow">
        <div className="ml-4 flex-grow">
          <p className="font-semibold text-base text-gray-600 capitalize mb-2 dark:text-white flex justify-between">
            <span>{item.name}</span>
            <span>{item?.cost[0]?.amount} Bs</span>
          </p>
          <div className="flex items-center justify-between text-sm text-gray-500">
            <div>
              {item.barcode ? (
                <>
                  <AiOutlineBarcode className="mr-1 mb-1 text-gray-400 inline" />
                  {item.barcode}
                </>
              ) : (
                'Sin código de barras'
              )}
            </div>
            <div>{item.sku ? `SKU: ${item.sku}` : 'Sin SKU'}</div>
          </div>
        </div>
        <div>
          <div
            className={
              'text-right rounded-xl p-1 px-2 mb-1 bg-gray-200 text-gray-500 flex flex-row justify-between space-x-3'
            }
          >
            <div>
              <div className="text-primary-900">Existencia:</div>
              <div className="text-primary-900">En Físico:</div>
            </div>
            <div>
              <div className={`${getStatusColors(+quantity).text} opacity-50`}>
                {formatAmount(quantity, item.unit)}
              </div>
              <input
                type="number"
                style={{
                  height: '22px',
                  marginTop: '2px',
                  marginLeft: '8px',
                  textAlign: 'right',
                  width: '76px',
                  background: 'transparent',
                  border: 'none',
                }}
                value={existence.to_assign.toString()}
                onChange={(e) => changeQuantity(existence, e.target.value)}
                min="1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

interface AdjustExistenceProps {
  existences: IExistence[]
  onClose: Function
  location: IWarehouse
}

interface IItemToAdjust extends IExistence {
  to_assign: string
}

interface IItemCardProps {
  existence: IItemToAdjust
  changeQuantity: Function
}

export default AdjustExistence
